import { Injector } from '@angular/core';
import { functionCtaType } from '@app/finxone-web-frontend/app/lib/utils/cta-button-actions/cta-button-actions.utils';
import {
  addDirectorAction,
  removeDirectorAction,
  saveDirectorAction,
  savePrimaryDirectorInfoAction,
} from '@app/finxone-web-frontend/app/lib/utils/cta-button-actions/onboarding-zone/director-actions.utils';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';

export const directorActions: Map<ButtonActionType, functionCtaType> = new Map([
  [
    ButtonActionType.ADD_DIRECTOR,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      addDirectorAction(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.SAVE_DIRECTOR,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      saveDirectorAction(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.REMOVE_DIRECTOR,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      removeDirectorAction(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.SAVE_PRIMARY_DIRECTOR_INFO,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      savePrimaryDirectorInfoAction(injector, attri.widgetProperties);
    },
  ],
]);
